import React, { useState, useEffect } from 'react';
import './IndicadorConexion.css'; // Asegúrate de crear también el CSS en la misma carpeta
import { checkInternetResources } from '../../endpoints';

const IndicadorConexion = () => {
  const [isOnline, setIsOnline] = useState(true);

  // Función que consulta a tu FastAPI
  const verificarConectividad = async () => {
    
        checkInternetResources.checkInternet().then(async response => {
            if (response.status === 200) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        })
        .then(data => {
            setIsOnline(data === true);
        })
        .catch(error => {
            console.error(error);
            setIsOnline(false);
        });
    
  };

  useEffect(() => {
    // 1. Verificación inmediata al cargar
    verificarConectividad();

    // 2. Revisar cada 10 segundos
    const intervalo = setInterval(() => {
      verificarConectividad();
    }, 10000); 

    // 3. Si el navegador detecta offline total, cambia de inmediato
    const mapearOfflineNativo = () => setIsOnline(false);
    window.addEventListener('offline', mapearOfflineNativo);

    // Limpieza de eventos e intervalos
    return () => {
      clearInterval(intervalo);
      window.removeEventListener('offline', mapearOfflineNativo);
    };
  }, []);

  return (
    <div className="status-container">
      <span className={`dot ${isOnline ? 'online' : 'offline'}`}></span>
      <span>{isOnline ? 'Conectado' : 'Sin Internet'}</span>
    </div>
  );
};

export default IndicadorConexion;